import { displayNotImplemented } from "../../services/Notifications/NotificationServices";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img src="/skull.svg" alt="Logo" className="footer-logo-img" />
          <a href= "#root" className="footer-logo-text">Киберштаб</a>
        </div>
        <div className="footer-sections">
          <div className="footerSection">
            <h3 className="footerSection-title">Продукты</h3>
            <ul className="footerSection-list">
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Экосистема</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Устройства</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Приложение</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Инф. система</a></li>
            </ul>
          </div>
          <div className="footerSection">
            <h3 className="footerSection-title">События</h3>
            <ul className="footerSection-list">
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Календарь</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Полигоны</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Организаторы</a></li>
            </ul>
          </div>
          <div className="footerSection">
            <h3 className="footerSection-title">Сообщество</h3>
            <ul className="footerSection-list">
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Команды</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Устройства</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Приложение</a></li>
              <li><a href='/calendar' className="footerSection-link">Инф. система</a></li>
            </ul>
          </div>
          <div className="footerSection">
            <h3 className="footerSection-title">О нас</h3>
            <ul className="footerSection-list">
              <li><a href="https://vk.com/ruscybershtab" className="footerSection-link">О команде</a></li>
              <li><a href="https://vk.com/ruscybershtab" className="footerSection-link">Блог</a></li>
              <li><a onClick={()=>{displayNotImplemented()}} className="footerSection-link">Карьера</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
